import { Component, ElementRef, Inject, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from '../dialog.component';


@Component({
  selector: 'app-incentive-view-component',
  templateUrl: './incentive-view-component.component.html',
  styleUrls: ['./incentive-view-component.component.scss']
})
export class IncentiveViewComponentComponent implements OnInit {
  @ViewChild('mapElement') mapElement: ElementRef;
  skLoading: boolean = false;
  user_details: any = {};
  attedence_data: any = {};
  check_in_data: any = [];
  array: any = [];
  myMap: any;
  map: any;
  dateTimeKM: string;
  latestLocation: any;
  incentive_details: any;
  total_qty: any;
  total_price: any;
  loader:boolean=false;
  

  total_incentive_amount: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
    public dialogs: MatDialog,
    public toast: ToastrManager,
    public service: DatabaseService,
    public dialog: DialogComponent,
    public dialogRef: MatDialogRef<IncentiveViewComponentComponent>) { 

      this.getDetails()
    }

  ngOnInit() {
  }



  ngAfterViewInit() {


  }

  close() {
    this.dialogRef.close();
  }


  getDetails() {
    this.skLoading = true;
    this.service.post_rqst({ 'id': this.data.id,}, "Target/achievementBrandWise")
      .subscribe((result => {
        if (result['statusCode'] == 200) {
          this.incentive_details = result['achievement_data'];
          console.log(this.incentive_details)

           // Calculate totals
        this.total_qty = this.incentive_details.reduce((acc, curr) => acc + parseFloat(curr.total_qty || 0), 0);
        this.total_price = this.incentive_details.reduce((acc, curr) => acc + parseFloat(curr.total_price || 0), 0);
        this.total_incentive_amount = this.incentive_details.reduce((acc, curr) => acc + parseFloat(curr.incentive_amount || 0), 0);
      
          this.skLoading = false;
        } else {
          this.toast.errorToastr(result['statusMsg'])
        }
      }))
  }
  
 


}
